export default __webpack_public_path__ + "928a3106f78ee5db9d8a197fde58fe6c.jpg";